import React, { useEffect,useState } from "react";
import Api from '../../../api/global.service';
import ApiUrls from '../../../constants/Api';
import DataTable from 'react-data-table-component';
import estiloGeneral from '../../../nuup/componentes/Tablas/estiloGeneral';
import  '../../../nuup/styles/Tablas.css'
import BlockUi from 'react-block-ui';
import HerramientasTablas from '../../../nuup/componentes/Tablas/HerramientasTablas/HerramientasTablas';
import getUrlFiltros from '../../../nuup/componentes/Tablas/HerramientasTablas/Modulos/Filtrado/Herramientas/getUrlFiltros';
import ListadoInventariosHistorialExportar from './ListadoInventariosHistorialExportar';

var dataArray = [];
const ListadoHistorialInventarios = (props) => {
	const [blocking, setBlocking] = useState(false);
	const [datosFiltrados, setDatosFiltrados] = useState([]);
	const [filtradoAlert, setFiltradoAlert] = useState(false);

	const columns = [

		{
			name: 'ID UGRJ',
			selector: 'id_ugrj',
			sortable: true,
			right: false
		},
		{
			name: 'ID Rancho',
			selector: 'id_rancho',
			sortable: true,
			right: false
		},

		{
			name: 'Proveedor',
			selector: 'nombre_proveedor',
			sortable: true,
			right: false
		},

		{
			name: 'Fecha Inicio',
			selector: 'fecha_inicio',
			sortable: true,
			right: false
		},
		{
			name: 'Fecha Fin',
			selector: 'fecha_fin',
			sortable: true,
			right: false
		},

		{
			name: 'Total',
			selector: 'total',
			sortable: true,
			right: false
		},

		{
			name: 'Linea',
			selector: 'linea',
			sortable: true,
			right: false
		},
		{
			name: 'Secas',
			selector: 'secas',
			sortable: true,
			right: false
		},
		{
			name: 'Becerras',
			selector: 'becerras',
			sortable: true,
			right: false
		},
		{
			name: 'Novillas',
			selector: 'novillas',
			sortable: true,
			right: false
		},
		{
			name: 'Vaquillas',
			selector: 'vaquillas',
			sortable: true,
			right: false
		},
		{
			name: 'Toros',
			selector: 'toros',
			sortable: true,
			right: false
		},
		{
			name: 'Fecha de registro',
			selector: 'created_at',
			maxWidth: '200px',
			sortable: true,
			right: false
		}
	];

	useEffect(() => {
		obtenerSeguimiento();
	}, []);

	  const obtenerSeguimiento = (filtrado = false)  => {
		setBlocking(true);
		Api.getAll(getUrlFiltros(filtrado,ApiUrls.ranchos.historial)).then(response => {
			dataArray = response.data.data; 
			setDatosFiltrados(dataArray);
			setBlocking(false);
		}).catch(e => {
			setBlocking(false);
		});
	  }

	const filtrarUsuarios = () => {
		// Validar que existan elementos seleccionados
		if(localStorage.getItem('filtro_tipo') > 0 && localStorage.getItem('filtro_valor').length > 0){
			obtenerSeguimiento(true);
		}else{
			obtenerSeguimiento();
		}
	};


	const handleChange = (datosFiltrados) => {setDatosFiltrados(datosFiltrados);}

	const conditionalRowStyles = [
		{
		  when: row => row.toggleSelected,
		  style: {
			backgroundColor: "#dadada",
			userSelect: "none"
		  }
		}
	  ];

	return (
		<BlockUi tag="div" blocking={blocking}>

			<HerramientasTablas 
				txtBusqueda="Buscar" 
				datosTabla={dataArray} 
				urlRegistrar=""
				columnasFiltrar={["nombre_proveedor","id_ugrj","id_rancho","fecha_inicio","fecha_fin","created_at"]}
				exportar={ListadoInventariosHistorialExportar}
				onFiltrar={(datosFiltrados) => handleChange(datosFiltrados)}
				funcionFiltrar={filtrarUsuarios}
				filtrarRegistros={false}
				filtros={['productor']}
				filtradoAlert={filtradoAlert}
			/>

          <DataTable
            pagination
			paginationPerPage={15}
            columns={columns}
            data={datosFiltrados}
			noDataComponent={'Sin datos por mostrar'}
			customStyles={estiloGeneral}
			conditionalRowStyles={conditionalRowStyles}
          />

		</BlockUi>
    );
  };
export default ListadoHistorialInventarios;
